/** Management stays on its separate loopback ingress, outside the customer API. */
export function localManagementUrl(location: Pick<Location, 'protocol' | 'hostname' | 'port'> = window.location): string | null {
  if (location.protocol !== 'http:' || location.port !== '8080'
    || !['localhost', '127.0.0.1', '[::1]'].includes(location.hostname)) return null
  return `http://${location.hostname}:9090/`
}
